import { Component } from '@angular/core';
import { KeyValuePipe } from '@angular/common';

interface Legend {
	label: string;
	className: string;
}

@Component({
	selector: 'app-legend',
	standalone: true,
	imports: [KeyValuePipe],
	templateUrl: './legend.component.html',
	styleUrl: './legend.component.scss',
})
export class LegendComponent {
	readonly legendItems: { left: Legend; right: Legend }[] = [
		{ left: { className: 'red-square', label: 'Zabierz' }, right: { className: 'green-square', label: 'Zostaw' } },
		{
			left: { className: 'blue-square', label: 'Przejad przez' },
			right: { className: 'yellow-square', label: 'Zaawansowane' },
		},
	];
}
